<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_ATTH_GRP_BSC_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              ref="smComboFrame0"
              :pageId="pageId"
              :selectedMd="frame0.selectData.COD_MDLE"
              :selectedSmd="frame0.selectData.COD_SMDLE"
              :customMdList="codes.emptyOption"
              :customSmdList="codes.emptyOption"
              :disabled="true"
              class="dp_flex"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ATTH_GRP_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.attachGroupId }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ATTH_GRP_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model="frame0.attachGroupName"
              :disabled="true"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EXPL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <textarea
              v-model="frame0.attachGroupContent"
              :disabled="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_USR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-user-name-link
              :pageId="pageId"
              :displayType="'1'"
              :displayLanguageId="frame0.displayLanguageIdRegistration"
              :knoxId="frame0.knoxIdRegistration"
              :userName="frame0.userNameRegistration"
              :userGlobalName="frame0.userGlobalNameRegistration"
              :departmentName="frame0.departmentNameRegistration"
              :departmentEnglishName="frame0.departmentEnglishNameRegistration"
              :type="'link'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_DTM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.firstRegistrationDTM }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDFC_USR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-user-name-link
              :pageId="pageId"
              :displayType="'1'"
              :displayLanguageId="frame0.displayLanguageIdModification"
              :knoxId="frame0.knoxIdModification"
              :userName="frame0.userNameModification"
              :userGlobalName="frame0.userGlobalNameModification"
              :departmentName="frame0.departmentNameModification"
              :departmentEnglishName="frame0.departmentEnglishNameModification"
              :type="'link'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDFC_DTM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.finalModificationDTM }}
            </div>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_ATTH_GRP_SET_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ATTH_ITEM_MGT_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <!-- <sui-yn-select
              :selected="frame0.selectData.COD_ATTH_ITEM_MGT_YN"
              :disabled="true"
            /> -->
            <sui-radio
              v-model="frame0.attachItemManagementYn"
              value="Y"
              :disabled="true"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="frame0.attachItemManagementYn"
              value="N"
              :disabled="true"
            >
              No
            </sui-radio>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_IMG_PRVW_APPY_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <!-- <sui-yn-select
              :selected="frame0.selectData.COD_IMG_PRVW_APPY_YN"
              :disabled="true"
            /> -->
            <sui-radio
              v-model="frame0.imagePreviewApplyYn"
              value="Y"
              :disabled="true"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="frame0.imagePreviewApplyYn"
              value="N"
              :disabled="true"
            >
              No
            </sui-radio>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CPCT_LIMIT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame0.attachRestrictionSize"
              :disabled="true"
              :readonly="false"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DLOAD_HIS_MGT_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <!-- <sui-yn-select
              :selected="frame0.selectData.COD_DLOAD_HIS_MGT_YN"
            /> -->
            <sui-radio
              v-model="frame0.downloadHistoryManagementYn"
              value="Y"
              :disabled="true"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="frame0.downloadHistoryManagementYn"
              value="N"
              :disabled="true"
            >
              No
            </sui-radio>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DLOAD_RSN_INP_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <!-- <sui-yn-select
              :selected="frame0.selectData.COD_DLOAD_RSN_INP_YN"
              :disabled="true"
            /> -->
            <sui-radio
              v-model="frame0.downloadReasonInputYn"
              value="Y"
              :disabled="true"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="frame0.downloadReasonInputYn"
              value="N"
              :disabled="true"
            >
              No
            </sui-radio>
          </div>
          <div class="col-xs-1 nodata" />
          <div class="col-xs-3" />
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onClickCancel"
      >
        {{ $t('MSG_BTN_CLOSE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMD_00006_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    selectedGridRowData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      codes: CommonConstants.selectOptions(),
      frame0: {
        selectData: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
        },
        attachGroupId: '',
        attachGroupName: '',
        attachGroupContent: '',
        finalModificationUserId: '',
        finalModificationDTM: '',
        firstRegistrationUserId: '',
        firstRegistrationDTM: '',
        attachRestrictionSize: '',
        knoxIdModification: '',
        userNameModification: '',
        userGlobalNameModification: '',
        departmentNameModification: '',
        departmentEnglishNameModification: '',
        knoxIdRegistration: '',
        userNameRegistration: '',
        userGlobalNameRegistration: '',
        departmentNameRegistration: '',
        departmentEnglishNameRegistration: '',
        displayLanguageIdRegistratio: '',
        displayLanguageIdModification: '',
        attachItemManagementYn: '',
        imagePreviewApplyYn: '',
        downloadHistoryManagementYn: '',
        downloadReasonInputYn: '',
      },
    };
  },
  watch: {
    selectedGridRowData(obj) {
      if (obj) {
        this.selectDataFormInput(obj);
      }
    },
  },
  datasets: [],
  mounted() {
    this.$nextTick(() => {
      this.selectDataFormInput(this.selectedGridRowData);
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    selectDataFormInput(obj) {
      utils.forEach(this.frame0, (value, key) => {
        if (utils.isEqual(key, 'selectData')) {
          this.frame0[key].COD_MDLE.key = obj.moduleCode;
          this.frame0[key].COD_SMDLE.key = obj.subModuleCode;
        } else {
          this.frame0[key] = obj[key];
        }
      });
    },
    onClickCancel() {
      this.$emit('onClickClose');
    },
  },
};
</script>

  <style scoped>
  </style>
